/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { CheckAliveQueryResponse, CheckAlive400, CheckAlive401, CheckAlive404, CheckAlive409, CheckAlive500 } from "../../types/CheckAlive.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getCheckAliveUrl() {
  const res = { method: 'GET', url: `/api/me/alive` as const }
  return res
}

/**
 * {@link /api/me/alive}
 */
export async function checkAlive(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CheckAliveQueryResponse, ResponseErrorConfig<CheckAlive400 | CheckAlive401 | CheckAlive404 | CheckAlive409 | CheckAlive500>, unknown>({ method : "GET", url : getCheckAliveUrl().url.toString(), ... requestConfig })
  return res.data
}